import { toDataURL } from "./Utils";

/**
 * Search user products by name.
 * @param {string} token - Auth token
 * @param {string} productName - Product name to search
 * @param {number} pageNumber - Page number
 * @param {object} prevPage - Previous search page (for pagination)
 * @returns {Promise<object>} - The search result page
 */
export async function searchUserProducts(
  token,
  productName,
  pageNumber = 0,
  pageSize = 10,
  prevPage = null
) {
  const SERVER_BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
  const params = new URLSearchParams();
  params.append("pageNumber", pageNumber);
  params.append("pageSize", pageSize);

  const res = await fetch(
    `${SERVER_BASE_URL}products/${productName}?${params.toString()}`,
    {
      headers: {
        Authorization: token,
      },
    }
  );
  const newPage = await res.json();
  if (prevPage && prevPage.products) {
    newPage.products = [...prevPage.products, ...newPage.products];
  }
  return newPage;
}

/**
 * Load product images as data URLs.
 * @param {Array} products - List of products
 * @param {string} token - Auth token
 * @returns {Promise<Array>} - List of products with displayUrl property
 */

export const loadProductImages = async (token, products) => {
  return await Promise.all(
    products.map(async (product) => {
      if (!product.imageURL) return product;
      const image = await toDataURL(product.imageURL, token);
      product.displayUrl = image;
      return product;
    })
  );
};
